import { useEffect, forwardRef, useImperativeHandle, useRef, useState } from 'react';

import WheelCanvas from '../WheelCanvas';
import { useWheelData } from '@lib/hooks/useWheelData';
import Notification from '@components/Notification';
import { platformName } from '@services/utils.service';

const KeywordWheel = forwardRef((props, ref) => {
  const { interactionState } = props;
  const {
    winner,
    wheelId,
    setting,
    streamId,
    winnerInfo,
    wheelState,
    platformType,
    currentRosResult,
    startInteraction,
    currentRosFeature,
    newWheelUser,

    setWinner,
    setWinnerInfo,
    pollForUsers,
    updateWinner,
    handleWheel,
  } = useWheelData(s => ({
    winner: s.winner,
    wheelId: s.wheelId,
    setting: s.setting,
    streamId: s.streamId,
    winnerInfo: s.winnerInfo,
    wheelState: s.wheelState,
    platformType: s.platformType,
    currentRosResult: s.currentRosResult,
    startInteraction: s.startInteraction,
    currentRosFeature: s.currentRosFeature,
    newWheelUser: s.newWheelUser,
    setWinner: s.setWinner,
    setWinnerInfo: s.setWinnerInfo,
    pollForUsers: s.pollForUsers,
    updateWinner: s.updateWinner,
    handleWheel: s.handleWheel,
  }));

  const prevSettings = useRef({ setting, options: null });
  const isPreview = (window?.location?.href?.includes('preview') || window?.location?.href?.includes('sandbox'));
  const [showNotification, setShowNotification] = useState(true);

  useEffect(() => {
    if (isPreview) return;

    if (!winnerInfo && wheelState === 'empty') {
      setShowNotification(true);
    } else {
      setShowNotification(false);
    }

    if (wheelId === null || !!currentRosResult?.[0]?.options || winnerInfo) return;
    pollForUsers(!setting?.enableKeyword);

    if (wheelState !== 'empty') return;
    const intervalId = setInterval(() => pollForUsers(!setting?.enableKeyword), 3000);
    return () => clearInterval(intervalId);
  }, [wheelId,
    wheelState,
    winnerInfo,
    startInteraction,
    currentRosResult,
    setting?.wheelShowUser,
    setting?.wheelKeyword,
    setting?.enableKeyword]);

  useEffect(() => {
    if (!winner) return;
    if (wheelState === 'spin') return;
    updateWinner();
  }, [winner, winnerInfo, wheelState]);

  useEffect(() => {
    if (wheelId || currentRosResult[0]?.options) return;
    setWinner(null);
    setWinnerInfo(null);
    handleWheel({ interactionId: null });
    updateWinner();
  }, [wheelId, currentRosResult]);

  useEffect(() => {
    if (!props.showInstantCustomisationPopup) {
      prevSettings.current = { setting, options: null };
    }
  }, [props.showInstantCustomisationPopup, setting]);

  useEffect(() => {
    if (!props.showInstantCustomisationPopup) return;

    const prev = prevSettings.current.setting;
    if (setting?.wheelKeyword === prev?.wheelKeyword) return;

    setWinner(null);
    setWinnerInfo(null);
    handleWheel({ interactionId: null });
  }, [
    props.showInstantCustomisationPopup,
    setting?.wheelKeyword
  ]);

  useImperativeHandle(ref, () => ({ newWheelUser }));

  const handleCloseNotification = () => setShowNotification(false);

  return (
    <>
      {showNotification &&
        <Notification platformName={platformName[platformType]} handleCloseNotification={handleCloseNotification}
          layoutMode={props.layoutMode} currentRosFeature={currentRosFeature} />
      }
      <div id='choice-circle-div' className={'w-full h-full'}>
        <div className='relative h-full rounded-lg overflow-hidden'>
          <div className={'h-full flex justify-center items-center'}>
            <WheelCanvas
              isPreview={false}
              streamId={streamId}
              splitDiv={props.splitDiv}
              playSound={props.playSound}
              layoutMode={props.layoutMode}
              stopFeature={props.stopFeature}
              isFullScreen={props.isFullScreen}
              currentIndex={props.currentIndex}
              playResultSound={props.playResultSound}
              playButtonSound={props.playButtonSound}
              currentRosResult={props.currentRosResult}
              showInstantCustomisationPopup={props.showInstantCustomisationPopup}
            />
          </div>
        </div>
      </div>
    </>
  );
});

export default KeywordWheel;
